THEME.archive = {
  init: function() {
    
  function click_read_more_article_content_operator(e) {
    e.preventDefault();
    e.stopPropagation();
    var _btn_hide=jQuery(this).data('hide');
    jQuery(_btn_hide)
      .removeClass('article--content--read-more')
      .removeClass('article--multiple--read-more');
    remove_sticky_styles();
    theme_status_lazy_load();
    $themeWin.trigger("resize").trigger("scroll");
  } /* click on read more */

  /* ==========================================================================================================
  ===  EVENTS  ================================================================================================
  ============================================================================================================= */

  /* == DOCUMENT READY ======================================================================================== */
  /* == DOCUMENT READY END ==================================================================================== */

  /* == DOCUMENT CLICK ======================================================================================== */
  $themeDoc.on('click', '.article--content--read-more__btn',click_read_more_article_content_operator); /* === CONTENT === */
  /* == DOCUMENT CLICK END ==================================================================================== */

  /* ==========================================================================================================
  ===  EVENTS END =============================================================================================
  ============================================================================================================= */



  }
};
